import { render, staticRenderFns } from "./seed-edit-form.html?vue&type=template&id=72e24928&scoped=true&"
import script from "./seed-edit-form.js?vue&type=script&lang=js&"
export * from "./seed-edit-form.js?vue&type=script&lang=js&"
import style0 from "./SeedEditForm.vue?vue&type=style&index=0&id=72e24928&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e24928",
  null
  
)

component.options.__file = "SeedEditForm.vue"
export default component.exports